import React, { useState } from 'react'

import { EventQuestionsFormComponent } from '../../../components/events/forms/questions/EventQuestionsFormComponent'

import { useAppSelector } from '../../../store/hooks'
import { selectedEvent } from '../../../store/events/eventsSlice'

import FirestoreService from '../../../services/firestoreService'
import { CONST } from '../../../const/const'

import useToasterHelper from '../../../helpers/ToasterHelper'

interface IProps {
  onSetEventTab: (tab: string) => void
  onSetNextEventTab: (tab: string) => void
  handleModal: (showHide: boolean, typeOfModal: string, data?: any) => void
  dataToPassOn?: any
  mainEvent?: any
  nextEventTab: string
  eventTab: string
}

export const ShowsDetailPageEventQuestions: React.FC<IProps> = (props) => {
  const toasterFunctions = useToasterHelper()

  const [data, setData] = useState<any>(null)
  const selectedEventR = useAppSelector(selectedEvent)
  const eventId = selectedEventR.Event?.id ?? ''

  const validFormHandler = async (fields: any) => {
    let updated = true

    await new Promise((resolve) => {
      FirestoreService.updateItem(CONST.DATA.FIRESTORE.LATEST.COLLECTIONS.EVENTS.NAME, eventId, {
        ...fields,
      })
        .then(() => setData(fields))
        .catch((reason) => {
          updated = false
          console.error('validFormHandler:' + reason)
        })
        .finally(() => {
          resolve(true)
        })
    })

    return {
      updated,
      onSetEventTab:
        props.nextEventTab === '' ? props.onSetEventTab : props.onSetEventTab(props?.nextEventTab),
      onSetNextEventTab: props.onSetNextEventTab(''),
    }
  }

  const invalidFormHandler = async () => {
    props.onSetNextEventTab('')
    toasterFunctions.error({ message: 'Please check required fields below.' })
  }

  const invalidAndValidFormHandler = async () => {
    props.onSetNextEventTab('')
    toasterFunctions.error({ message: 'Please check required fields below.' })
  }

  return (
    <EventQuestionsFormComponent
      data={data}
      validFormHandler={validFormHandler}
      invalidFormHandler={invalidFormHandler}
      onInvalidAndExit={invalidAndValidFormHandler}
      nextEventTab={props.nextEventTab}
      eventTab={props.eventTab}
    />
  )
}
